import { useUser } from "./user-context";

export function useAuth() {
  const { session, isSessionLoading } = useUser();
  return {
    session,
    isPending: isSessionLoading,
    isAuthenticated: Boolean(session?.user?.id),
  };
}

export function getSafeRedirectPath(
  search: string,
  fallbackPath = "/dashboard"
) {
  const searchParams = new URLSearchParams(search);
  const redirectParam = searchParams.get("redirect");

  if (!redirectParam) return fallbackPath;

  try {
    const url = new URL(redirectParam, window.location.origin);
    if (url.origin !== window.location.origin) return fallbackPath;
    return url.pathname + url.search + url.hash;
  } catch {
    return fallbackPath;
  }
}
